export default __webpack_public_path__ + "static/media/img9.d8fe8912.png";